import request from 'sb-request'
import actions from 'redux/actions'
import { getState } from 'redux/core'
import { constants, links, localStorage } from 'common/helpers'


const _subscribeToStockNotification = (productId) =>
  request.post(`rest/product/${productId}/notify-out-of-stock`, {
    withErrorModal: false,
  })
    .then(
      () => actions.misc.notifications.show('OutOfStockSubscription'),
      ({ error, message, statusCode }) => {
        if (error === 'product_already_in_out_of_stock_notification') {
          actions.misc.notifications.show('OutOfStockSubscription')
        }
        else {
          actions.models.modals.open(constants.modals.ServerError, {
            content: message,
            statusCode,
          })
        }
      }
    )

const subscribeToStockNotification = (productId) => {
  const { models: { me: { isLoggedIn } } } = getState()

  if (!isLoggedIn) {
    localStorage.setItem(constants.localStorageNames.stockNotificationSubscriptionProductId, productId)
    actions.models.modals.close(constants.modals.ProductDetails)
    actions.models.router.push(links.register)

    return Promise.resolve()
  }

  return _subscribeToStockNotification(productId)
}

const resolvePostponedStockNotificationSubscription = () => {
  const productId = localStorage.getItem(constants.localStorageNames.stockNotificationSubscriptionProductId)

  if (!productId) {
    return Promise.resolve()
  }

  localStorage.removeItem(constants.localStorageNames.stockNotificationSubscriptionProductId)

  return _subscribeToStockNotification(productId)
}


export default {
  subscribeToStockNotification,
  resolvePostponedStockNotificationSubscription,
}
